<template>
	<b-container class="w-75 text-dark">
		<b-row class="heading mh-100 m-0 p-0" style="height: 100%; max-height: 100%;" align-v="center">
			<b-col class="m-0 p-0 text-center">
				<template v-if="$asyncComputed.desktops.updating && desktops === null">
					<RingLoader :color="'#343a40'" :size="64" :loading="true" class="m-auto py-5" />
					Retrieving assigned desktops...
				</template>
				<template v-else-if="$asyncComputed.desktops.success && desktops.length">
					<Launch :type="type" :poolUUID="poolUUID" :wsUUID="wsUUID" v-if="doLaunch" />
					<template v-else-if="action === 'launch' && poolUUID">
						<RingLoader :color="'#343a40'" :size="64" :loading="true" class="m-auto py-5" />
						<h3 class="heading">Assigning desktop</h3>
						Requesting desktop from {{ desktop.poolName }}...
					</template>
				</template>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	import Launch from '@/components/Desktop/Launch';
	import { RingLoader } from '@saeris/vue-spinners';
	
	export default
	{
		name: 'desktop',
		props: [ 'type', 'action', 'uuid' ],
		components: { Launch, RingLoader },
		asyncComputed:
		{
			desktops:
			{
				lazy: false,
				async get()
				{
					let desktops = await this.portalAPI.get('/desktop/' + this.type)
						.then(
							resp => resp.data,
							err => this.$logger.error(err)
						);
					
					this.$logger.debug('User desktops loaded', desktops);
					
					return desktops;
				}
			}
		},
		computed:
		{
			desktop: function()
			{
				if(!this.desktops || !this.uuid)
					return undefined;
				
				let uuid = this.uuid;
				
				return (uuid === 'default') ? this.desktops[0] : this.desktops.filter(d => ((this.type === 'oal') ? d.poolUUID === uuid : d.wsUUID === uuid))[0];
			},
			poolUUID: function()
			{
				if(this.type !== 'oal' || !this.desktop)
					return undefined;
				
				return this.desktop.poolUUID;
			},
			wsUUID: function()
			{
				if(!this.uuid || !this.desktop)
					return undefined;
				
				return (('wsUUID' in this.desktop) ? this.desktop.wsUUID : undefined);
			},
			
			portalAPI: function()
			{
				return this.$root.$refs.app.portalAPI;
			},
			
			doLaunch: function()
			{
				return Boolean(this.action === 'launch'
					&& this.wsUUID);
			}
		},
		watch:
		{
			poolUUID: function(nVal, oVal)
			{
				if(nVal && this.action === 'launch' && !this.wsUUID)
				{
					this.$logger.info('Request desktop assignment from ' + this.desktop.poolName);
					this.assignWS();
				}
			}
		},
		methods:
		{
			getWS: function(uuid)
			{
				if(this.desktops == undefined)
					return this.desktops;
				
				let desktop = (uuid === 'default') ? this.desktops[0] : this.desktops.filter(d => d.wsUUID === uuid)[0];
				
				return (desktop && ('wsUUID' in desktop)) ? desktop.wsUUID : undefined;
			},
			
			assignWS: async function()
			{
				if(this.type !== 'oal' || !this.poolUUID)
					return undefined;
				
				let result = await this.portalAPI.post('/desktop/' + this.type + '/' + this.poolUUID + '/assign')
					.then(
						(res) =>
						{
							if(!/^2\d\d$/.test(res.status))
								return this.showError(new Error('Desktop assignment failed!'));
							
							this.$asyncComputed.desktops.update();
							
							return true;
						},
						(err) => 
						{
							this.$logger.error('Desktop Assignment Error', err);
							
							if(err.response)
								this.showError(err.response.data.message);
							else
								this.showError('Desktop Assignment Error');
						}
					);
			},
			showError: function(message) { return this.$root.$refs.app.showError(message); }
		},
		data() { return {}; }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.container
	{
		height: 100%;
		max-height: 100%;
		
		overflow: auto;
		
		padding: 12px;
	}
	
	.fade-enter-active, .fade-leave-active
	{
		transition: all 1s;
	}
</style>
